import { styled } from "styled-components";

export const Spacer = styled("div")(({ theme }) => ({
  width: "100%",
  minHeight: "1px",
}));
